import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { cloneDeep } from "lodash";
// Components
import { Button } from "components/Buttons";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "layouts/Dialog";
import PromoVideoForm from "pages/OwnerPage/QuizFormPage/TabContentPages/SystemPages/PromoVideo/PromoVideoForm";
// Context
import { usePausePreviewSync } from "./PreviewSyncContext";
import { useCommitVersion } from "./VersionHistoryContext";

type Props = {
  open: boolean;
  onClose: () => void;
}

// Pauses the parent's preview-hash recompute while open (see
// PreviewSyncContext) so the leading video tile only updates once this
// dialog closes — via Cancel (reverted) or Apply (kept) — never live while
// editing, matching QuizPageEditDialog / QuizStyleEditDialog.
const PromoVideoEditDialog:FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  usePausePreviewSync();

  const commitVersion = useCommitVersion();

  const { getValues, reset } = useFormContext<any>();

  const [snapshot] = useState(() => cloneDeep(getValues()));

  const handleClose = () => {
    reset(snapshot);
    onClose();
  };

  const handleApply = () => {
    commitVersion(`Edited: ${t('pages.quizForm.promoVideoLabel')}`);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} size="sm">
      <DialogTitle title={t('pages.quizForm.promoVideoLabel')} onClose={handleClose} />
      <DialogContent>
        <PromoVideoForm />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} className="mr-2">
          {t('buttons.cancel')}
        </Button>
        <Button variant="contained" onClick={handleApply}>
          {t('buttons.apply')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PromoVideoEditDialog;
